export type LastPaymentStatus = 'paid' | 'failed' | 'pending';

/** Newest payment on the owner's Stripe customer; amount is in whole currency units. */
export interface LastPayment {
  amount: number;
  currency: string;
  status: LastPaymentStatus;
  paidAt: string;
}

export const LAST_PAYMENT_STATUS_LABELS: Readonly<Record<LastPaymentStatus, string>> = Object.freeze({
  paid: 'Paid',
  failed: 'Failed',
  pending: 'Pending'
});
